<template>
  <div id="kiosk-login-page" class="row w-100 justify-content-center">
    <div class="col-12 col-md-7 col-lg-6">
      <h1 class="mb-2">Salon sign-in</h1>
      <p class="mb-4">Enter the kiosk password to continue.</p>
      <div class="card card-body text-left" style="border-radius: 14px;">
        <error-banner v-if="error" :message="error" class="mb-3"/>
        <form @submit.prevent="tryLogin">
           <label class="font-weight-bold mb-2">Password</label>
          <password-input v-model="password" placeholder="Password" @keydownEnter="tryLogin"/>
          <div v-if="recaptchaEnabled" class="mt-3">
            <turnstile-widget ref="turnstileWidget" execution="execute" @verified="handleRecaptchaToken" @errored="handleRecaptchaError" @expired="clearRecaptcha" @timedOut="clearRecaptcha" @retrying="clearRecaptcha" @interactiveStart="pauseRecaptchaWait" @interactiveEnd="resumeRecaptchaWait"></turnstile-widget>
            <validation-message v-if="recaptchaMessage" :message="recaptchaMessage"></validation-message>
          </div>
          <button type="submit" class="btn btn-primary mt-4 w-100" :disabled="submitting || pendingRecaptcha || !password">
            {{ submitting || pendingRecaptcha ? 'Signing in…' : 'Unlock Kiosk' }}
          </button>
        </form>
        <div class="p2 mt-3 text-center text-muted">
          If you've forgotten the password, an admin can change it.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SelectedSiteIdMixin } from '@/mixins/Booking/SelectedSiteIdMixin'
import { RecaptchaSettingsCacheMixin } from '@/mixins/Booking/RecaptchaSettingsCacheMixin'
import { TurnstileExecuteMixin } from '@/mixins/Booking/TurnstileExecuteMixin'
import { WebApi } from '@/services/WebApi'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import PasswordInput from '../Authentication/PasswordInput.vue'
import ErrorBanner from '../ErrorValidation/ErrorBanner.vue'
import TurnstileWidget from '../Booking/TurnstileWidget.vue'
import ValidationMessage from '../ErrorValidation/ValidationMessage.vue'

export default {
  name: 'KioskLogin',
  mixins: [SelectedSiteIdMixin, RecaptchaSettingsCacheMixin, TurnstileExecuteMixin],
  data () {
    return { password: '', submitting: false, error: '' }
  },
  methods: {
    tryLogin () {
      const self = this
      if (self.submitting || self.pendingRecaptcha || !self.password) {
        return
      }
      self.error = ''
      if (self.recaptchaEnabled && !self.recaptcha) {
        self.requestRecaptcha(self.performLogin)
        return
      }
      self.performLogin()
    },
    performLogin () {
      const self = this
      self.submitting = true
      self.error = ''
      WebApi.post(`Authentication/Site/${self.selectedSiteId}/Kiosk/Login`, { password: self.password, recaptcha: self.recaptcha })
        .then(() => { self.$emit('authenticated') })
        .catch(error => {
          self.error = ErrorHelper.isNotAuthenticated(error)
            ? 'Invalid username or password'
            : ErrorHelper.getError(error)
          self.resetRecaptcha()
        })
        .finally(() => { self.submitting = false })
    }
  },
  components: {
    'password-input': PasswordInput,
    'error-banner': ErrorBanner,
    'turnstile-widget': TurnstileWidget,
    'validation-message': ValidationMessage
  }
}
</script>

<style scoped>
@media (max-width: 576px) {
  #kiosk-login-page h1 { font-size: 1.375rem !important; }
}
</style>
